var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPensionOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_386_482)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_386_482",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_386_482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C8.96 2 6.5 4.46 6.5 7.5C6.5 10.54 8.96 13 12 13C15.04 13 17.5 10.54 17.5 7.5C17.5 4.46 15.04 2 12 2ZM14.06 7.97H13.8L13.48 9.02C13.42 9.21 13.25 9.34 13.04 9.35C12.83 9.35 12.65 9.23 12.59 9.04L12 7.45L11.41 9.04C11.33 9.24 11.13 9.35 10.97 9.35H10.95C10.75 9.35 10.57 9.21 10.51 9.02L10.19 7.98H9.93C9.67 7.98 9.46 7.77 9.46 7.51C9.46 7.25 9.65 7.05 9.9 7.04L9.66 6.27C9.58 6.02 9.72 5.76 9.97 5.68C10.22 5.61 10.49 5.75 10.56 5.99L11 7.42L11.54 5.97C11.61 5.8 11.78 5.68 11.99 5.68C12.2 5.68 12.38 5.79 12.44 5.97L12.98 7.42L13.42 5.99C13.49 5.74 13.76 5.61 14.01 5.68C14.26 5.76 14.4 6.02 14.32 6.27L14.08 7.04C14.33 7.05 14.52 7.25 14.52 7.51C14.52 7.77 14.31 7.98 14.05 7.98L14.06 7.97Z",
    fill: "#1E9B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.97 12.02C20.97 12.02 20.67 12 20.19 12C18.8 12 15.91 12.2 14.09 13.71C12.5 15.04 12.09 17.2 12 18.55C11.91 17.2 11.5 15.04 9.91 13.71C8.09 12.2 5.2 12 3.81 12C3.33 12 3.03 12.02 3.03 12.02C3.03 12.02 2.6 15.69 5.05 17.73C6.36 18.82 8.24 19.32 9.72 19.56L10.38 20.1C10.78 20.43 11 20.86 11 21.3V22H13V21.3C13 20.86 13.22 20.43 13.62 20.1L14.27 19.56H14.28C14.38 19.54 14.48 19.53 14.58 19.51C16.01 19.25 17.73 18.74 18.95 17.73C21.4 15.69 20.97 12.02 20.97 12.02Z",
    fill: "#1E9B6B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPensionOn);
export default __webpack_public_path__ + "static/media/pension_on.1dfd3e1bd5aea206f8b2fd0b58262ce9.svg";
export { ForwardRef as ReactComponent };